import { PreRenderService } from '../../services/pre-render.service';
import { TemplateRef, ViewContainerRef } from '@angular/core';
/**
 * Adds the template content to the DOM only if the platform is the requested platform
 */
var IfPlatformDirective = /** @class */ (function () {
    function IfPlatformDirective(_templateRef, _viewContainer, prerenderService) {
        this._templateRef = _templateRef;
        this._viewContainer = _viewContainer;
        this.prerenderService = prerenderService;
        this._hasView = false;
    }
    Object.defineProperty(IfPlatformDirective.prototype, "ifPlatform", {
        set: function (platform) {
            var satisfied = (platform == 'browser' && this.prerenderService.isBrowserMode)
                || (platform == 'server' && this.prerenderService.isServerMode);
            if (satisfied && !this._hasView) {
                this._viewContainer.createEmbeddedView(this._templateRef);
                this._hasView = true;
            }
            else if (!satisfied && this._hasView) {
                this._viewContainer.clear();
                this._hasView = false;
            }
        },
        enumerable: true,
        configurable: true
    });
    return IfPlatformDirective;
}());
export { IfPlatformDirective };
